import { render, staticRenderFns } from "./CustomerHubHealthPanel.vue?vue&type=template&id=13a56240&scoped=true"
import script from "./CustomerHubHealthPanel.vue?vue&type=script&lang=js"
export * from "./CustomerHubHealthPanel.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubHealthPanel.vue?vue&type=style&index=0&id=13a56240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a56240",
  null
  
)

export default component.exports